module.exports = __webpack_public_path__ + "img/puk_shin2_pc.e82f49ba.png";